(function () {
  'use strict';

  function getCartForm() {
    return document.getElementById('CartPageForm');
  }

  function syncBeforeCheckout(form) {
    if (typeof window.LoantiRebuildCartDeliveryState === 'function') {
      window.LoantiRebuildCartDeliveryState(form);
    }
  }

  function validateCheckout(form) {
    syncBeforeCheckout(form);

    if (typeof window.LoantiValidateCartCheckout === 'function') {
      return window.LoantiValidateCartCheckout(form);
    }

    var termsCheckbox = form.querySelector('.cart__terms-checkbox');
    if (termsCheckbox && !termsCheckbox.checked) {
      return { ok: false, code: 'terms', message: 'Zaakceptuj regulamin.' };
    }

    return { ok: false, code: 'delivery', message: 'Wybierz metodę dostawy.' };
  }

  function showCheckoutError(form, check) {
    if (typeof window.LoantiShowCartCheckoutError === 'function') {
      window.LoantiShowCartCheckoutError(form, check);
      return;
    }

    var error = form.querySelector('[data-loanti-delivery-error="1"]');
    if (error) {
      error.textContent = check.message;
      error.hidden = false;
    }
  }

  function hideCheckoutError(form) {
    var error = form.querySelector('[data-loanti-delivery-error="1"]');
    if (error) {
      error.hidden = true;
    }
  }

  function submitCheckout(form, button) {
    button.classList.add('btn--loading');

    var checkoutInput = form.querySelector('[data-loanti-checkout-input="1"]');
    if (!checkoutInput) {
      checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.setAttribute('data-loanti-checkout-input', '1');
      form.appendChild(checkoutInput);
    }

    form.submit();
  }

  function handleCheckoutClick(form, checkoutBtn, event) {
    syncBeforeCheckout(form);
    console.log(
      '[Loanti Cart] checkout click',
      window.LoantiCartDeliveryState ? JSON.stringify(window.LoantiCartDeliveryState) : 'brak stanu'
    );

    if (typeof window.LoantiCanCheckout === 'function' && window.LoantiCanCheckout()) {
      hideCheckoutError(form);
      submitCheckout(form, checkoutBtn);
      return;
    }

    if (event) {
      event.preventDefault();
    }

    var check = validateCheckout(form);
    if (!check.ok) {
      showCheckoutError(form, check);
      checkoutBtn.classList.remove('btn--loading');
      return;
    }

    hideCheckoutError(form);
    submitCheckout(form, checkoutBtn);
  }

  function bindCheckoutButton(form) {
    var checkoutBtn = form.querySelector('[data-loanti-cart-checkout="1"]');
    if (!checkoutBtn || checkoutBtn.getAttribute('data-loanti-cart-checkout-bound') === '1') {
      return;
    }

    checkoutBtn.setAttribute('data-loanti-cart-checkout-bound', '1');

    checkoutBtn.addEventListener(
      'click',
      function (event) {
        handleCheckoutClick(form, checkoutBtn, event);
      },
      false
    );

    form.addEventListener(
      'submit',
      function (event) {
        var submitter = event.submitter;
        var isCheckoutSubmit =
          (submitter && submitter.getAttribute('data-loanti-cart-checkout') === '1') ||
          (submitter && submitter.name === 'checkout') ||
          form.querySelector('[data-loanti-checkout-input="1"]');

        if (!isCheckoutSubmit) {
          return;
        }

        syncBeforeCheckout(form);

        if (typeof window.LoantiCanCheckout === 'function' && window.LoantiCanCheckout()) {
          return;
        }

        if (typeof window.LoantiBlockCartCheckout === 'function' && window.LoantiBlockCartCheckout(form, event)) {
          return;
        }

        var check = validateCheckout(form);
        if (!check.ok) {
          event.preventDefault();
          showCheckoutError(form, check);
          checkoutBtn.classList.remove('btn--loading');
        }
      },
      true
    );
  }

  function bindCrossSellAdd(form) {
    form.addEventListener('click', function (event) {
      var button = event.target.closest('[data-loanti-cart-cross-add="1"]');
      if (!button || button.disabled || !form.contains(button)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      var variantId = button.getAttribute('data-variant-id');
      if (!variantId) {
        return;
      }

      button.disabled = true;
      button.classList.add('is-loading');

      var addUrl =
        window.theme && window.theme.routes && window.theme.routes.cartAdd
          ? window.theme.routes.cartAdd
          : '/cart/add.js';

      fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: parseInt(variantId, 10),
          quantity: 1
        })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('add_failed');
          }
          return response.json();
        })
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          button.disabled = false;
          button.classList.remove('is-loading');
        });
    });
  }

  function initCartPage() {
    var form = getCartForm();
    if (!form) {
      return;
    }

    bindCheckoutButton(form);
    bindCrossSellAdd(form);

    if (typeof window.LoantiSyncCartCheckoutState === 'function') {
      window.LoantiSyncCartCheckoutState(form);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartPage);
  } else {
    initCartPage();
  }

  document.addEventListener('page:loaded', initCartPage);
  document.addEventListener('cart:updated', function () {
    var form = getCartForm();
    if (form && typeof window.LoantiSyncCartCheckoutState === 'function') {
      window.setTimeout(function () {
        window.LoantiSyncCartCheckoutState(form);
      }, 200);
    }
  });
})();
